/* tslint:disable */
/* eslint-disable */
import { mapValues } from '../runtime';
import type { ShopProductOptionChoice } from './ShopProductOptionChoice';
import {
  ShopProductOptionChoiceFromJSON,
  ShopProductOptionChoiceToJSON,
} from './ShopProductOptionChoice';

export interface ShopProductOption {
  id?: number;
  productId?: number;
  name?: string;
  type?: string;
  required?: boolean;
  sortOrder?: number;
  choices?: Array<ShopProductOptionChoice>;
}

export function ShopProductOptionFromJSON(json: any): ShopProductOption {
  return ShopProductOptionFromJSONTyped(json, false);
}

export function ShopProductOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShopProductOption {
  if (json == null) { return json; }
  return {
    'id': json['id'] == null ? undefined : json['id'],
    'productId': json['productId'] == null ? undefined : json['productId'],
    'name': json['name'] == null ? undefined : json['name'],
    'type': json['type'] == null ? undefined : json['type'],
    'required': json['required'] == null ? undefined : json['required'],
    'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
    'choices': json['choices'] == null ? undefined : (json['choices'] as Array<any>).map(ShopProductOptionChoiceFromJSON),
  };
}

export function ShopProductOptionToJSON(value?: ShopProductOption | null): any {
  if (value == null) { return value; }
  return {
    'id': value['id'],
    'productId': value['productId'],
    'name': value['name'],
    'type': value['type'],
    'required': value['required'],
    'sortOrder': value['sortOrder'],
    'choices': value['choices'] == null ? undefined : (value['choices'] as Array<any>).map(ShopProductOptionChoiceToJSON),
  };
}
